import { Paper, Typography } from '@mui/material';
import { isEmpty, map } from 'lodash';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { DataWrapper, FormControls, HelpTooltip } from 'components';
import { TranslationNamespace } from 'i18n';
import { Group } from 'types';

type Props = {
  groups: Group[];
  hideTitle?: boolean;
};

export const ShopPayoutGroups: React.FC<Props> = ({ groups, hideTitle }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });
  const { t: tCommon } = useTranslation();

  return (
    <Fragment>
      {!hideTitle && (
        <Typography variant="subtitle1">
          {t('sections.payout_groups.title')}
          <HelpTooltip title={t('sections.payout_groups.description')} />
        </Typography>
      )}
      <DataWrapper isEmpty={isEmpty(groups)}>
        <FormControls>
          {map(groups, (group) => (
            <Paper key={group.id} sx={{ p: 4 }}>
              <div className="tw-flex tw-items-center">
                <div className="tw-flex-1">{group.name}</div>
                {`${group.payoutOrdersAccessTimeout} ${tCommon(
                  'suffixes.minutes',
                )}`}
              </div>
            </Paper>
          ))}
        </FormControls>
      </DataWrapper>
    </Fragment>
  );
};
